import { Modal } from 'antd';
import { parse } from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { isNumber } from '../../base/utils';
import { Note } from '../../helbest';
import { API } from '../../request/api';
import { _set_store } from '../../store/actions/login_actions';

class ModalLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      city_name: '',
      city_list: [],
      province_name: '',
      province_list: [],
      selected_city: '',
      selected_province: '',
      show_notif_modal: false
    };
  }

  componentDidMount() {
    this.GET_PROVINCE();
  }

  GET_PROVINCE() {
    const { history } = this.props;
    API.get
      .locationProvince()
      .then((response) => {
        if (response.success) {
          this.setState({
            province_list: response.data,
            loading: false
          });
          try {
            const qs = parse(history?.location.search);
            if (qs.prov && isNumber(qs.prov)) {
              const _prov_id = parseInt(qs.prov, 10);
              const _prov = response.data.filter((item) => item.id === _prov_id)[0];
              if (_prov) {
                this.setState({
                  selected_province: _prov.id,
                  province_name: _prov.name,
                  loading: true,
                  selected_city: '',
                  city_list: []
                });
                this.GET_CITY(_prov.id);
              }
            }
          } catch {
            console.error('Error!');
          }
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  }

  GET_CITY(province_id = 1) {
    const { history } = this.props;

    API.get
      .locationCities(province_id)
      .then((response) => {
        if (response.success) {
          this.setState({
            city_list: response.data,
            loading: false
          });
          if (response.data.length === 1) {
            this.setState({
              selected_city: response.data[0].id,
              city_name: response.data[0].name
            });
            try {
              const qs = parse(history?.location.search);
              if (qs.prov && isNumber(qs.prov)) {
                this.set_store();
              }
            } catch {
              console.error('Error!');
            }
          }
          try {
            const qs = parse(history?.location.search);
            if (qs.city && isNumber(qs.city)) {
              const _city_id = parseInt(qs.city, 10);
              const _city = response.data.filter((item) => item.id === _city_id)[0];
              if (_city) {
                this.setState({
                  selected_city: _city.id,
                  city_name: _city.name
                });
                this.set_store();
              }
            }
          } catch {
            console.error('Error!');
          }
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  }

  async select_province(e) {
    let pn;
    const { province_list } = this.state;

    province_list.filter((item) => (item.id === parseInt(e, 10) ? (pn = item.name) : null));
    this.setState({
      loading: true,
      selected_province: e,
      selected_city: '',
      province_name: pn,
      city_list: []
    });
    this.GET_CITY(e);
  }

  async select_city(e) {
    let cn;
    const { city_list } = this.state;
    city_list.filter((item) => (item.id === parseInt(e, 10) ? (cn = item.name) : null));
    this.setState({ selected_city: e, city_name: cn });
  }

  set_store() {
    const { selected_province, selected_city, province_name, city_name } = this.state;
    const { toInvisible, dispatch } = this.props;

    if (selected_province === '' || selected_city === '') {
      Note.error('لطفا استان و شهر خود را انتخاب کنید.');
      return;
    }

    dispatch(_set_store(selected_province, selected_city, '', province_name, city_name));

    this.setState({ loading: false });
    // this.props.categoryFunction(this.state.selected_city);
    // this.props.sliderFunction();
    toInvisible();
  }

  render() {
    const { visible } = this.props;
    const { selected_province, province_list, city_list, selected_city } = this.state;

    return (
      <Modal className="change-store-location" closable={false} footer={false} visible={visible}>
        <div className="text-center">
          <p className="font-16">انتخاب شهر و استان</p>
          <p className="change-store-label">انتخاب استان</p>
          <select
            className="change-store-select form-control border-red font-14 bg-transparent-05"
            onChange={(e) => this.select_province(e.target.value)}
            value={selected_province}>
            <option value=""> </option>
            {province_list?.map((x, i) => (
              <option key={i} value={x.id}>
                {x.name}
              </option>
            ))}
          </select>

          {selected_province !== '' ? (
            <>
              <p className="change-store-label">انتخاب شهر</p>
              <select
                className="change-store-select mt-3 form-control border-red font-14 bg-transparent-05"
                onChange={(e) => this.select_city(e.target.value)}
                value={selected_city}>
                <option value=""> </option>
                {city_list.map((x, i) =>
                  city_list.length === 1 ? (
                    <option key={i} selected value={x.id}>
                      {x.name}
                    </option>
                  ) : (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  )
                )}
              </select>
            </>
          ) : null}

          <div
            className="button flex-i center-content btn-h48 btn btn-red btn-300 line-none btn-round"
            onClick={() => this.set_store()}>
            ثبت
          </div>
        </div>
      </Modal>
    );
  }
}

const mstp = (state) => ({
  Login: state.Login
});

export default connect(mstp)(withRouter(ModalLocation));
